export const AUTHLOGIN = 'AUTHLOGIN'
export const STAGE_02 = 'STAGE_02'
export const UNI_INFO = 'UNI_INFO'
//

export const authLogin = (response) => ({
    type: AUTHLOGIN,
    payload: response,
})

export const uniInfo = (response) => ({
    type: UNI_INFO,
    payload: response,
})

export const stage_02 = (response) => ({
    type: STAGE_02,
    payload: response,
})
